import { render, staticRenderFns } from "./home.page.vue?vue&type=template&id=45661fcf"
import script from "./home.page.vue?vue&type=script&lang=js"
export * from "./home.page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports